import { ErrorBoundary } from "components/ErrorBoundary";
import React, { useContext, useEffect } from "react";
import { ExperimentAndSwitchContext } from "wrapper/ExperimentAndSwitchWrapper/context";
import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { get } from "../../logics/src/utils/helpers";
import { NewPaymentFailureProps } from "./@types";
import { PaymentFailureWrapper } from "./index";

/**
 * Component to check where payment failure flow is enabled or not and render
 * the failure bottom sheet component if flow is enabled
 */
export const NewPaymentFailureFlow = (props: NewPaymentFailureProps) => {
  const {
    showFallbackModeSheet,
    setShowFallbackModeSheet,
    isGPayIntentAvailable,
    timerCallback,
    theme,
  } = props;
  let params = new URLSearchParams(window?.location?.search);
  const { NewPaymentFailure } = useContext(ExperimentAndSwitchContext);
  const newPaymentFailureEnabled =
    NewPaymentFailure?.experimentEnabled && NewPaymentFailure?.switchEnabled;
  const paymentContext = useContext(PaymentContext);
  const paymentInfo = get(paymentContext, "paymentInfo");
  // used for handling the case when fallbackModes are null
  const customerId = get(paymentInfo, "customerId");
  const isPaymentInfoLoading = get(paymentContext, "isPaymentInfoLoading");
  const setLoading = get(paymentContext, "setLoading");
  const isGpayRazorpayIntentDetailsLoading = get(
    paymentContext,
    "isGpayRazorpayIntentDetailsLoading"
  );
  const fallbackModes = paymentInfo?.fallbackModes;
  const showBottomSheet = params.get("showFallbackBottomSheet") === "true" && showFallbackModeSheet;

  /**
   * when getInfo Data has been fetched but fallbackModes are null
   */
  useEffect(() => {
    if (!isPaymentInfoLoading && customerId && !fallbackModes) {
      setLoading(false);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [isPaymentInfoLoading]);

  /**
   * Do not render bottom if payment failure flow is not enabled OR
   * showFallbackModeSheet is false OR
   * fallbackModes does not exists or blank object OR
   * isGpayRazorpayIntentDetailsLoading is true
   */
  if (
    !(
      newPaymentFailureEnabled &&
      fallbackModes &&
      Object.keys(fallbackModes) &&
      !isGpayRazorpayIntentDetailsLoading
    )
  )
    return <></>;

  return (
    <ErrorBoundary message="Failed to load Payment Failure Component">
      <PaymentFailureWrapper
        showFallbackModeSheet={showFallbackModeSheet}
        showBottomSheet={showBottomSheet}
        theme={theme}
        setShowFallbackModeSheet={setShowFallbackModeSheet}
        isGPayIntentAvailable={isGPayIntentAvailable}
        timerCallback={timerCallback}
      />
    </ErrorBoundary>
  );
};
